export default __webpack_public_path__ + "static/media/GC_12.5d56aaed.png";